export class ErrorCode {
    public static CartIsNoLongerAvailable = 'CartIsNoLongerAvailable';
    public static AddonAgreementsAlreadySigned = 'AddonAgreementsAlreadySigned';
    public static EntityNotFound = 'EntityNotFound';
}
